import ErrorComponent from "web/Layout/Common/ErrorComponent";
import { SkeletonHeaderMenu } from "web/Layout/Common/SkeletonComponents";

import { useGetMenuQuery } from "web/features/api/graphQLApiSlice";

import MainMenuContainerWithCategoryIds from "./mainMenuContainerWithCategoryIds";

const MainMenuContainer = () => {
  const { data, isLoading, isError } = useGetMenuQuery();

  switch (true) {
    case isLoading: {
      return <SkeletonHeaderMenu />;
    }
    case isError: {
      return <ErrorComponent />;
    }
    default: {
      const menuData = data?.menu;
      return menuData ? (
        <MainMenuContainerWithCategoryIds menu={menuData} />
      ) : null;
    }
  }
};

export default MainMenuContainer;
